export const TASK_OUTBOX_KINDS = {
  transition: 'task.transition',
  create: 'task.create',
} as const;
